import React, { ReactNode, useState, useContext, createContext } from 'react';
import {
  IComputedFolder,
  IFolderComputeResult
} from '../../Models/trips/computed-folder.model';

export interface TripComputedFoldersContextType {
  computedFolders: IFolderComputeResult | null;
  setComputedFolders: (folders: IFolderComputeResult | null) => void;
  selectedComputedFolder: IComputedFolder | null;
  setSelectedComputedFolder: (folder: IComputedFolder | null) => void;
  refreshFolders: boolean;
  setRefreshFolders: (refresh: boolean) => void;
}

const TripComputedFoldersContext = createContext<
  TripComputedFoldersContextType | undefined
>(undefined);

export const TripComputedFoldersProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [computedFolders, setComputedFolders] =
    useState<IFolderComputeResult | null>(null);
  const [selectedComputedFolder, setSelectedComputedFolder] =
    useState<IComputedFolder | null>(null);
  const [refreshFolders, setRefreshFolders] = useState<boolean>(false);

  const value: TripComputedFoldersContextType = {
    computedFolders,
    setComputedFolders,
    selectedComputedFolder,
    setSelectedComputedFolder,
    refreshFolders,
    setRefreshFolders
  };

  return (
    <TripComputedFoldersContext.Provider value={value}>
      {children}
    </TripComputedFoldersContext.Provider>
  );
};

export const useTripComputedFolders = () => {
  const context = useContext(TripComputedFoldersContext);
  if (context === undefined) {
    throw new Error(
      'useTripComputedFolders must be used within a TripComputedFoldersProvider'
    );
  }
  return context;
};
